module.exports = __webpack_public_path__ + "static/key-regularhuman-215b685ed035adefa0c61ee35e1952cd.webp";